import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { WaybillCommentsModel, WaybillIdView } from '../../../../models';
import { ShipmentWaybillEndpoint } from '../../constants/shipment-waybill-endpoint';
import { getQueryStringFromObject } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class ShipmentWaybillCommentsService {
  constructor(private http: WrapperHttpService) {}

  getShipmentWaybillComments(waybillIdView: WaybillIdView): Observable<WaybillCommentsModel[]> {
    const url = `${API_URL}${ShipmentWaybillEndpoint.Base}${ShipmentWaybillEndpoint.Waybills}${
      ShipmentWaybillEndpoint.Comments
    }?${getQueryStringFromObject({
      ...waybillIdView,
    })}`;

    return this.http.withLoading().get(url);
  }

  saveShipmentWaybillComment(waybillIdView: WaybillIdView, comment: string): Observable<WaybillCommentsModel> {
    return this.http
      .withLoading()
      .post(
        `${API_URL}${ShipmentWaybillEndpoint.Base}${ShipmentWaybillEndpoint.Waybills}${ShipmentWaybillEndpoint.Comments}`,
        {
          waybill: waybillIdView,
          comment,
        },
      );
  }
}
